module.exports = __webpack_public_path__ + "static/img/xianshangkechen.0694f94.png";


//////////////////
// WEBPACK FOOTER
// ./static/goumai/xianshangkechen.png
// module id = fj6n
// module chunks = 14